import LegalLayout from './LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de Privacidad" updatedAt="febrero 2026">
      <p>
        Esta Política de Privacidad regula el tratamiento de <b>datos personales</b> de quienes visitan
        el sitio <b>priviax.cl</b> y utilizan la plataforma SaaS <b>Priviax</b> (en adelante, el &ldquo;Servicio&rdquo;).
        Está redactada conforme a la <b>Ley N.º 21.719 de Protección de Datos Personales de Chile</b> y
        cumple con los principios de licitud, finalidad, proporcionalidad, calidad, responsabilidad,
        seguridad y transparencia.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <p>
        <b>Auttobots SpA</b>, RUT <b>77.674.834-K</b>, con domicilio en Cerro el Plomo 5931 Of. 1213,
        Las Condes, Santiago de Chile, actúa como <b>responsable</b> del tratamiento de los datos
        personales que se recopilan a través del Servicio. Correo de contacto:{' '}
        <a href="mailto:hola@priviax.cl">hola@priviax.cl</a>.
      </p>
      <p>
        Cuando nuestros clientes utilizan Priviax para gestionar su propio cumplimiento, Auttobots
        SpA actúa como <b>encargado</b> respecto de los datos de titulares que el cliente carga en el
        sistema (por ejemplo, solicitantes ARCO+, colaboradores registrados en RAT). En esos casos el
        cliente es el <b>responsable</b> y Auttobots SpA únicamente los procesa bajo instrucción y
        contrato.
      </p>

      <h2>2. Datos personales que recopilamos</h2>
      <ul>
        <li><b>De cuenta:</b> nombre, apellido, correo electrónico, cargo, teléfono, contraseña (hasheada con bcrypt).</li>
        <li><b>De organización:</b> razón social, RUT, giro, industria, tamaño, sitio web, logo.</li>
        <li><b>De uso:</b> registros de acceso (fecha, hora, IP), acciones realizadas dentro del Servicio (bitácora inmutable).</li>
        <li><b>Técnicos:</b> tipo de navegador, sistema operativo, resolución de pantalla.</li>
        <li><b>De pago (futuro):</b> los procesa directamente Stripe. Auttobots SpA no almacena números de tarjeta.</li>
      </ul>

      <h2>3. Finalidad y base legal</h2>
      <p>Utilizamos sus datos para:</p>
      <ul>
        <li>Prestar el Servicio contratado (base legal: <i>ejecución de contrato</i>, art. 12 letra b).</li>
        <li>Facturar y cumplir obligaciones tributarias (base legal: <i>obligación legal</i>, art. 12 letra c).</li>
        <li>Comunicarnos con usted sobre cambios del Servicio, incidencias o soporte (base legal: <i>ejecución de contrato</i>).</li>
        <li>Mejorar la plataforma y detectar abuso (base legal: <i>interés legítimo</i>, art. 12 letra f).</li>
        <li>Enviar comunicaciones comerciales solo con su <i>consentimiento</i> explícito, revocable en cualquier momento.</li>
      </ul>

      <h2>4. Plazo de conservación</h2>
      <p>
        Conservamos sus datos mientras su cuenta esté activa y durante los <b>6 años</b> posteriores
        a la baja, plazo alineado con la obligación tributaria chilena (art. 17 del Código Tributario).
        Los registros de auditoría se conservan por el mismo período. Puede solicitar la eliminación
        anticipada ejerciendo su derecho de cancelación (ver punto 6).
      </p>

      <h2>5. Con quién compartimos sus datos</h2>
      <ul>
        <li><b>Encargados de tratamiento:</b> proveedores que nos permiten operar el Servicio, bajo contrato con cláusulas de protección de datos:
          <ul>
            <li>Infraestructura y base de datos (MongoDB Atlas / hosting Chile o Brasil).</li>
            <li>Envío de correos transaccionales (Resend).</li>
            <li>Procesamiento de pagos (Stripe — no compartimos datos sensibles bancarios).</li>
            <li>Modelos de lenguaje del Copiloto (Anthropic Claude vía Emergent LLM Key) — las conversaciones no incluyen identificadores personales del cliente.</li>
          </ul>
        </li>
        <li><b>Autoridades:</b> Agencia de Protección de Datos Personales, tribunales o autoridad competente, cuando exista requerimiento fundado.</li>
        <li><b>Nunca:</b> vendemos ni cedemos sus datos a terceros con fines comerciales.</li>
      </ul>

      <h2>6. Sus derechos (ARCO+)</h2>
      <p>Como titular usted puede ejercer en cualquier momento y sin costo los derechos consagrados en los artículos 4 a 11 bis de la Ley 21.719:</p>
      <ul>
        <li><b>Acceso</b> a los datos que tenemos suyos.</li>
        <li><b>Rectificación</b> cuando sean inexactos o estén desactualizados.</li>
        <li><b>Cancelación</b> cuando ya no sean necesarios o retire su consentimiento.</li>
        <li><b>Oposición</b> a un tratamiento específico.</li>
        <li><b>Portabilidad</b> — recibir sus datos en formato estructurado.</li>
        <li><b>Bloqueo</b> temporal mientras resolvemos una controversia.</li>
      </ul>
      <p>
        Puede ejercer estos derechos escribiendo a{' '}
        <a href="mailto:hola@priviax.cl">hola@priviax.cl</a>. Responderemos en un plazo máximo de{' '}
        <b>15 días hábiles</b>. Si considera que no atendemos correctamente su solicitud puede reclamar
        ante la <b>Agencia de Protección de Datos Personales</b>.
      </p>

      <h2>7. Transferencia internacional</h2>
      <p>
        Algunos proveedores (Stripe, Resend, Anthropic) están fuera de Chile. En cada caso hemos
        verificado que ofrecen un <b>nivel de protección adecuado</b> conforme al artículo 27 y sus
        contratos incluyen cláusulas contractuales tipo. Puede solicitar la lista actualizada.
      </p>

      <h2>8. Medidas de seguridad</h2>
      <ul>
        <li>Cifrado en tránsito (TLS 1.2+) y en reposo.</li>
        <li>Contraseñas hasheadas con bcrypt (nunca en texto plano).</li>
        <li>Aislamiento estricto entre organizaciones (multi-tenant por <code>organization_id</code>).</li>
        <li>Bitácora inmutable de accesos y cambios.</li>
        <li>Copias de respaldo diarias con retención de 30 días.</li>
        <li>Control de acceso por rol (RBAC) y sesiones con caducidad configurable.</li>
      </ul>

      <h2>9. Datos de menores</h2>
      <p>
        Priviax es un producto B2B dirigido a empresas. No recopilamos intencionalmente datos de
        menores de 14 años. Si detecta que un menor ha proporcionado datos, escríbanos y los
        eliminaremos.
      </p>

      <h2>10. Cambios a esta política</h2>
      <p>
        Podemos actualizar esta Política cuando cambie la ley aplicable, agreguemos nuevas
        funcionalidades o incorporemos encargados de tratamiento. Los cambios se publicarán en esta
        misma página con la fecha de actualización y, cuando sean sustanciales, le avisaremos por
        correo con al menos 15 días de anticipación.
      </p>

      <h2>11. Contacto</h2>
      <p>
        <b>Auttobots SpA</b> · RUT 77.674.834-K · Cerro el Plomo 5931 Of. 1213, Las Condes, Santiago, Chile ·{' '}
        <a href="mailto:hola@priviax.cl">hola@priviax.cl</a>. Responsable interno de protección de
        datos: por designar formalmente antes del 1 de diciembre de 2026.
      </p>
    </LegalLayout>
  );
}
